import React, { createContext, useContext, useMemo, useState } from "react";

/* Gedən AI try-on generasiyasının QLOBAL izi (sahibin istəyi, 2026-10-05):
   müştəri «Bağla» ilə çıxıb gəzməyə davam edəndə sorğu ölmür — nəticə
   hazır olanda ekranın aşağısındakı kiçik pəncərədə görünür, klik böyüdür.
   Axios promise komponent unmount olanda ləğv olunmur, ona görə izləmə
   burada, komponentlərdən yuxarıda yaşayır. */

const TryonJobCtx = createContext(null);

export function TryonJobProvider({ children }) {
  const [job, setJob] = useState(null);
  const [uiOpen, setUiOpen] = useState(false);

  const value = useMemo(() => ({
    job,
    uiOpen,
    setUiOpen,
    clear: () => setJob(null),
    /** Generasiya promise-ini izə götür. `meta` = {title, handle}. */
    track: (meta, promise) => {
      const startedAt = Date.now();
      setJob({ status: "pending", startedAt, ...meta });
      promise
        .then((data) => setJob((current) => (
          current && current.startedAt === startedAt
            ? { ...current, status: "done", resultUrl: data?.result_url || null }
            : current
        )))
        .catch(() => setJob((current) => (
          current && current.startedAt === startedAt
            ? { ...current, status: "error" }
            : current
        )));
    },
  }), [job, uiOpen]);

  return <TryonJobCtx.Provider value={value}>{children}</TryonJobCtx.Provider>;
}

export function useTryonJobs() {
  return useContext(TryonJobCtx);
}
